/**
 * Simple logger for the reader app.
 * - error: Always logs (production and development) for debugging critical issues
 * - warn/debug: Only log in development to reduce noise
 */
const isDev = process.env.NODE_ENV !== 'production';

export const logger = {
  error: (message: string, error?: unknown) => {
    // Always log errors, even in production, for debugging
    console.error(`[Reader] ${message}`, error);
  },
  warn: (message: string, data?: unknown) => {
    if (isDev) {
      console.warn(`[Reader] ${message}`, data);
    }
  },
  debug: (message: string, data?: unknown) => {
    if (isDev) {
      console.log(`[Reader] ${message}`, data);
    }
  },
};
